import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getDeepLink} from '../../actions/DeepLink';
import {useHistory, useLocation} from '../../imports/Router';
import {selecetusertype} from '../../selectors/User';
import {useMutation} from 'react-query';
import {useApi} from '../../providers/ApiProvider';
import {AppState} from 'react-native';
import {showAlert} from '../../actions/AlertActions';
import {useTranslation} from 'react-i18next';
import {getVehicle} from '../../actions/vehicle';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {showSheet} from '../../actions/SheetActions';

// To go to the deep link path after login or registration,
// the deep link parameters are saved in redux and deleted after completion.

const getParams = route => {
  return new Promise((resolve, reject) => {
    try {
      var regex = /[?&]([^=#]+)=([^&#]*)/g,
        params = {},
        match;
      while ((match = regex.exec(route))) {
        params[match[1]] = match[2];
      }
      resolve(params);
    } catch {
      reject(null);
    }
  });
};

const DeepLink = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const {api} = useApi();
  const {t} = useTranslation();
  const {enseraf, token, userStatus, locationPermition} = useSelector(state =>
    selecetusertype(state),
  );
  let myToken = token;

  const detectorRoute = async (
    route1,
    route2,
    routeParams = {},
    registerAuthparams = {},
  ) => {
     let myToken2 = await AsyncStorage.getItem('token');
     if (!myToken) {
      myToken=myToken2
   }
    if (myToken) {
      if (
        enseraf ||
        !locationPermition ||
        userStatus == 'active' ||
        userStatus == 'profile_submitted' ||
        userStatus == 'profile_rejected'
      ) {
        dispatch(getDeepLink(routeParams));
        if (!!route1) {
          history.push(route1);
        }
        history.push(route2);
      } else {
        dispatch(getDeepLink(registerAuthparams));
        history.replace('/register');
      }
    } else {
      dispatch(getDeepLink(registerAuthparams));
      history.replace('/auth');
    }
  };

  const getQrCodeDataMutation = useMutation({
    mutationFn: async body => {
      return api.vehiclesGetId(body);
    },
    onSuccess: response => {
      let qrcodeData = {
        deepLinkType: response?.Data?.VehicleType?.toLocaleLowerCase(),
        deepLinkId: response?.Data?.Id,
      };
      detectorRoute('', '/main/map', qrcodeData, qrcodeData);
    },
  });

  const myTripsMutation = useMutation({
    mutationFn: async () => {
      return api.myActiveTrip();
    },
    onSuccess: response => {
      const data = response?.Data;
      const activeReserve = response?.Data?.ActiveReserve;
      const activeTrip = response?.Data?.ActiveTrip;

      if (activeTrip !== null) {
        dispatch(
          showSheet({
            sheetId: 'tripMessage',
            sheetProps: {
              type: 'existing_trip',
            },
          }),
        );
        const responseVehicle = data?.ActiveTrip?.Vehicle;
        const vehicle = {
          battery: responseVehicle?.Battery,
          code_prefix: responseVehicle?.CodePrefix,
          discount_percent: responseVehicle?.DiscountPercent,
          discount_duration: responseVehicle?.DiscountDuration ,
          discounted_price: responseVehicle?.DiscountedPrice,
          name: responseVehicle?.Name,
          pause_coefficient: responseVehicle?.PauseCoefficient,
          plaque: responseVehicle?.Plaque,
          last_valid_lat: responseVehicle?.Latitude,
          last_valid_long: responseVehicle?.Longitude,
          price: responseVehicle?.Price,
          type: responseVehicle?.Type,
          vehicle_id: responseVehicle?.VehicleId,
        };
        dispatch(
          getVehicle({
            tripId: data?.ActiveTrip?.Id,
            vehicle: vehicle,
            stop: data.ActiveTrip.LastDetailStatus == 'pause' ? true : false,
            refresh: true,
            reserveId: null,
            reservetime: null,
            activeSeconds: data?.ActiveTrip?.ActiveSeconds,
            pauseSeconds: data?.ActiveTrip?.PauseSeconds,
            activeMinutes: Math.round(data?.ActiveTrip?.ActiveSeconds / 60),
            pauseMinutes: Math.round(data?.ActiveTrip?.PauseSeconds / 60),
            money: data?.ActiveTrip?.Price,
          }),
        );
        history.replace('/main/map/drive');
      } else if (activeReserve !== null) {
        dispatch(
          showSheet({
            sheetId: 'tripMessage',
            sheetProps: {
              type: 'existing_reservation',
            },
          }),
        );
        let date = new Date(data?.ActiveReserve?.ExpireDate).getTime();
        const responseVehicle = data?.ActiveReserve?.Vehicle;
        dispatch(
          getVehicle({
            vehicle: {
              battery: responseVehicle.Battery,
              code_prefix: responseVehicle?.CodePrefix,
              discount_percent: responseVehicle?.DiscountPercent,
              discount_duration: responseVehicle?.DiscountDuration ,
              discounted_price: responseVehicle?.DiscountedPrice,
              last_valid_lat: responseVehicle?.Latitude,
              last_valid_long: responseVehicle?.Longitude,
              name: responseVehicle.Name,
              pause_coefficient: responseVehicle?.PauseCoefficient,
              plaque: responseVehicle?.Plaque,
              price: responseVehicle?.Price,
              type: responseVehicle?.Type,
              vehicle_id: responseVehicle?.VehicleId,
            },
            reserveId: data.ActiveReserve.Id,
            reservetime: date,
            tripId: null,
            money: 0,
            stop: false,
          }),
        );
        history.replace('/main/map/reserved');
      }
    },
  });

  const linkHandler = route => {
    getParams(route).then(params => {
      if (
        params?.type?.toLocaleLowerCase() == 'bike' ||
        params?.type?.toLocaleLowerCase() == 'bicycle'
      ) {
        myTripsMutation.mutate();
      }
      switch (params?.type?.toLocaleLowerCase()) {
        case 'parking':
          let parkingData = {
            deepLinkType: 'parking',
            deepLinkId: params?.id,
          };
          detectorRoute('', '/main/map', parkingData, parkingData);
          break;
        case 'bike':
          let bikeData = {
            deepLinkType: 'bike',
            deepLinkId: params?.id,
          };
          detectorRoute('', '/main/map', bikeData, bikeData);
          break;
        case 'bicycle':
          let bicycleData = {
            deepLinkType: 'bicycle',
            deepLinkId: params?.id,
          };
          detectorRoute('', '/main/map', bicycleData, bicycleData);
          break;
        case 'qrcode':
          getQrCodeDataMutation.mutate({code: params?.code});
          dispatch(
            getDeepLink({
              deepLinkQrCode: params?.code,
            }),
          );
          break;
        case 'package':
          detectorRoute(
            '/main/dashboard',
            '/main/dashboard/buy-packages',
            {deepLinkId: params?.id},
            {
              deepLinkType: 'package',
              deepLinkId: params?.id,
            },
          );
          break;
        case 'invite':
          detectorRoute(
            '/main/dashboard',
            '/main/dashboard/invite-friends',
            {deepLinkType: 'invite'},
            {
              deepLinkType: 'invite',
            },
          );
          break;
        case 'credit':
          detectorRoute(
            '/main/dashboard',
            '/main/dashboard',
            {deepLinkType: 'credit'},
            {
              deepLinkType: 'credit',
            },
          );
          break;
        case 'dashboard':
          detectorRoute(
            '/main/dashboard',
            '/main/dashboard',
            {deepLinkType: 'dashboard'},
            {deepLinkType: 'dashboard'},
          );
          break;
        case 'deposit':
          detectorRoute(
            '/main/dashboard',
            '/main/dashboard/account-info',
            {deepLinkType: 'deposit'},
            {
              deepLinkType: 'deposit',
            },
          );
          break;
        case 'history':
          detectorRoute(
            '/main/dashboard',
            '/main/dashboard/trip-history',
            {deepLinkType: 'history'},
            {
              deepLinkType: 'history',
            },
          );
          break;
        case 'penalty':
          detectorRoute(
            '/main/dashboard',
            '/main/dashboard/payment-history',
            {deepLinkType: 'penalty'},
            {
              deepLinkType: 'penalty',
            },
          );
          break;
        case 'discount':
          detectorRoute(
            '',
            '/main/map',
            {deepLinkType: 'discount'},
            {deepLinkType: 'discount'},
          );
          break;
        case 'paymenthistory':
          detectorRoute(
            '/main/dashboard',
            '/main/dashboard/payment-history',
            {deepLinkType: 'paymentHistory'},
            {deepLinkType: 'paymentHistory'},
          );
          break;
        case 'freeride':
          detectorRoute(
            '/main/dashboard',
            '/main/dashboard/package-list',
            {deepLinkType: 'freeride'},
            {deepLinkType: 'freeride'},
          );
          break;
        case 'nationalrejected':
          detectorRoute(
            '/main/map',
            '/main/map',
            {deepLinkType: 'nationalrejected'},
            {deepLinkType: 'nationalrejected'},
          );
          break;
        case 'useraccount':
          detectorRoute(
            '/main/dashboard',
            '/main/dashboard/account-info',
            {deepLinkType: 'useraccount'},
            {deepLinkType: 'useraccount'},
          );
          break;
        case 'map':
          detectorRoute('', '/main/map', {}, {});
          break;
        default:
          break;
      }
    });
  };

  useEffect(() => {
    const subscrption = AppState.addEventListener(
      'change',
      handleAppStateChange,
    );
    return () => {
      subscrption.remove();
    };
  }, [location?.search]);

  function handleAppStateChange(nextAppState) {
    if (nextAppState !== 'background') {
      linkHandler(location?.search);
    }
  }

  useEffect(() => {
    linkHandler(location?.search);
  }, []);
};
export default DeepLink;
